import "./AppSection.css";
import { motion } from "framer-motion";
import {
  FiBell,
  FiActivity,
  FiMoon,
  FiThermometer,
  FiWifi,
  FiShield,
} from "react-icons/fi";
import motherBaby from "../../assets/images/mother-baby.jpg";

function AppSection() {
  return (
    <section className="app-section" id="app">
      <div className="container app-container">
        <motion.div
          className="app-left"
          initial={{ opacity: 0, x: -40 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true }}
        >
          <span>BYBEBEK MOBİL</span>

          <h2 className="section-title">
            Her şey
            <br />
            Tek Bir Uygulamada.
          </h2>

          <p className="section-subtitle">
            Bebeğinizin durumu hakkında anlamlı bildirimler alın, geçmiş
            verileri inceleyin ve tüm sensörleri tek ekrandan yönetin.
          </p>

          <div className="app-features">
            <div>
              <FiBell />
              <span>Anlık Bildirimler</span>
            </div>

            <div>
              <FiActivity />
              <span>Canlı Sensör Verileri</span>
            </div>

            <div>
              <FiMoon />
              <span>Uyku Geçmişi</span>
            </div>

            <div>
              <FiThermometer />
              <span>Sıcaklık Takibi</span>
            </div>

            <div>
              <FiWifi />
              <span>Yerel Ağ Bağlantısı</span>
            </div>

            <div>
              <FiShield />
              <span>Güvenli Erişim</span>
            </div>
          </div>
        </motion.div>

        <motion.div
          className="app-right"
          initial={{ opacity: 0, x: 40 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true }}
        >
          <div className="app-device-pair">
            <div className="phone app-main-phone">
              <div className="phone-top"></div>

              <div className="phone-screen">
                <div className="status-card">
                  <small>Bugün</small>

                  <h3>Her şey normal</h3>

                  <p>Bebeğiniz güvenli şekilde uyuyor.</p>
                </div>

                <div className="chart-card">
                  <div className="chart-line"></div>
                </div>

                <div className="sensor-grid">
                  <div className="sensor-card">
                    <span>Sıcaklık</span>
                    <strong>36.7°C</strong>
                  </div>

                  <div className="sensor-card">
                    <span>Nem</span>
                    <strong>%49</strong>
                  </div>

                  <div className="sensor-card">
                    <span>Uyku</span>
                    <strong>02:34</strong>
                  </div>

                  <div className="sensor-card">
                    <span>AI</span>
                    <strong>Aktif</strong>
                  </div>
                </div>
              </div>
            </div>

            <div className="app-lock-phone">
              <div className="app-lock-notch"></div>
              <img src={motherBaby} alt="Bybebek bildirim ekranı" />

              <div className="app-lock-time">
                <strong>09:41</strong>
                <span>Bybebek</span>
              </div>

              <div className="app-lock-notification">
                <div className="app-lock-icon">
                  <FiBell />
                </div>
                <div>
                  <strong>Bybebek</strong>
                  <span>Bebeğiniz uyandı.</span>
                </div>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
}

export default AppSection;
